module.exports = __webpack_public_path__ + "static/media/au.dff87541.png";